import { render } from "./StatusKenaikanPangkat.vue?vue&type=template&id=e607d98c&ts=true"
import script from "./StatusKenaikanPangkat.vue?vue&type=script&lang=ts"
export * from "./StatusKenaikanPangkat.vue?vue&type=script&lang=ts"

import "./StatusKenaikanPangkat.vue?vue&type=style&index=0&id=e607d98c&lang=scss"

import exportComponent from "/home/vendor/oesb/ispk-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__